/*
  Cart drawer upsells: order protection toggle and the partner pair add.

  Listeners are delegated from document because cart-drawer.js replaces the
  innerHTML of #CartDrawer on every cart change - anything bound directly to
  these buttons would be dead after the first interaction.
*/
(function () {
  'use strict';

  var BUSY = false;

  function sectionUrl() {
    return window.location.pathname;
  }

  // Mirrors what cart-drawer.js does, so the drawer updates without a reload.
  function renderDrawer(state, keepClosed) {
    var html = state && state.sections && state.sections['cart-drawer'];
    if (!html) {
      window.location.reload();
      return;
    }
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#CartDrawer');
    var live = document.querySelector('#CartDrawer');
    if (fresh && live) live.innerHTML = fresh.innerHTML;

    var bubbleHtml = state.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var b = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }

    var drawer = document.querySelector('cart-drawer');
    if (!keepClosed && drawer && typeof drawer.open === 'function') drawer.open();
    document.dispatchEvent(new CustomEvent('cd:upsell-updated'));
  }

  function fail(control) {
    if (control) control.removeAttribute('disabled');
    BUSY = false;
    var box = document.querySelector('#CartDrawer-CartErrors');
    if (box) box.textContent = 'We could not update your cart. Please try again.';
  }

  function post(url, body, control) {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || state.errors) { fail(control); return; }
        BUSY = false;
        renderDrawer(state);
      })
      .catch(function () { fail(control); });
  }

  document.addEventListener('click', function (e) {
    if (BUSY) return;

    /* ---- order protection ---- */
    var toggle = e.target.closest('.cd-tg');
    if (toggle) {
      // add-on rows share this switch; a row may carry an optional selling plan
        var row = toggle.closest('[data-cd-op], [data-cd-addon]');
      if (!row) return;
      e.preventDefault();
      BUSY = true;
      toggle.setAttribute('disabled', '');

      var on = row.getAttribute('data-in-cart') === 'true';
      // optimistic: the switch moves immediately, the cart catches up
      toggle.classList.toggle('is-on', !on);
      toggle.setAttribute('aria-checked', String(!on));

      if (on) {
        post('/cart/change.js', {
          id: row.getAttribute('data-key'),
          quantity: 0,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: sectionUrl(),
        }, toggle);
      } else {
        post('/cart/add.js', {
          items: [(function () {
              var line = { id: Number(row.getAttribute('data-variant')), quantity: 1 };
              var plan = Number(row.getAttribute('data-plan'));
              // a plan id makes this a subscription line rather than a one-off
              if (plan > 0) line.selling_plan = plan;
              return line;
            })()],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: sectionUrl(),
        }, toggle);
      }
      return;
    }

    /* ---- partner pair ---- */
    var add = e.target.closest('[data-cd-add]');
    if (add) {
      e.preventDefault();
      BUSY = true;
      add.setAttribute('disabled', '');
      post('/cart/add.js', {
        items: [{ id: Number(add.getAttribute('data-variant')), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: sectionUrl(),
      }, add);
    }
  });

  /*
    The drawer is rendered server-side with the cart as it was at that moment.
    Restore a page from the back/forward cache, or change the cart without
    re-rendering, and the gift panel can outlive the product it belongs to.
    Compare what the HTML assumed against the live cart and re-render if they
    disagree, so the drawer can never promise gifts for an absent product.
  */
  function reconcileOffer() {
    var marker = document.querySelector('#CartDrawer .cd-state');
    if (!marker) return;
    var handle = marker.getAttribute('data-gift-handle') || '';
    var rendered = marker.getAttribute('data-offer-live') === 'true';

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var live = handle
          ? cart.items.some(function (i) { return i.handle === handle; })
          : cart.item_count > 0;
        if (live === rendered) return null;
        var path = sectionUrl();
        var url = path + (path.indexOf('?') > -1 ? '&' : '?') + 'sections=cart-drawer';
        return fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (sections) { renderDrawer({ sections: sections }, true); });
      })
      .catch(function () { /* offline or blocked: leave the drawer as rendered */ });
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) reconcileOffer(); });
  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl && window.MutationObserver) {
    var wasOpen = drawerEl.classList.contains('active');
    new MutationObserver(function () {
      var isOpen = drawerEl.classList.contains('active');
      if (isOpen && !wasOpen) reconcileOffer();
      wasOpen = isOpen;
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(reconcileOffer, 400); });
  }

  if (document.readyState !== 'loading') reconcileOffer();
  else document.addEventListener('DOMContentLoaded', reconcileOffer);
})();
